import { Text } from '@/utils';

export const props = {
    props:
    {
        color:
        {
            type: String,
            default: 'default', // 'default', 'primary', 'secondary', 'success', 'warning', 'danger'
        },

        disabled:
        {
            type: Boolean,
            default: false,
        },

        fullWidth:
        {
            type: Boolean,
            default: false,
        },

        ghost:
        {
            type: Boolean,
            default: false,
        },

        href:
        {
            type: String,
            default: null,
        },

        loading:
        {
            type: Boolean,
            default: false,
        },

        link:
        {
            type: Boolean,
            default: false,
        },

        outline:
        {
            type: Boolean,
            default: false,
        },

        size:
        {
            type: String,
            default: null, // 'small', 'large'
        },

        text:
        {
            type: Boolean,
            default: false,
        },

        rounded:
        {
            type: String,
            default: null, // 'full', 'semi'
        },

        divClass:
        {
            type: String,
            default: ''
        }
    },
};

export const computed = {
    computed:
    {
        classes()
        {
            return Text.joinClass(
                'vh-button',
                this.link ? 'vh-button-link' :
                    this.ghost ? 'vh-button-ghost vh-button-ghost-default' :
                        this.text ? `vh-button-text vh-button-text-${this.color}` :
                            this.outline ? `vh-button-outline vh-button-outline-${this.color}` :
                                this.color && `vh-button-${this.color}`,
                this.size && `vh-button-${this.size}`,
                this.fullWidth && 'vh-width-1-1',
                this.rounded && `vh-button-${this.rounded}-rounded`,
            );
        },

        isAnchor()
        {
            return this.href !== undefined && this.href !== null;
        },
    },
};

export const methods = {
    methods:
    {
        onClick(e)
        {
            this.$emit('click', e);
        },
    },
};
